const InteractionEventName = {};
export default InteractionEventName;

InteractionEventName.LANE_SWITCH = "lane_switch";